import { createContext } from 'react';
import { DrxProfile } from '../api/profiles';

interface ProfileContextValue {
    // Profiles as last confirmed by the IDP, and the selection reconciled
    // against them. Prefer these over useIDPContext()'s `profiles` /
    // `selectedProfile`, which are rehydrated from a localStorage cache on
    // refresh and can be stale. `ready` is false until the first fetch
    // resolves, or stays false if the IDP could not be reached — callers
    // should fall back to the IDP context in that case.
    profiles: DrxProfile[];
    selectedProfileId: string | null;
    ready: boolean;
}

export const ProfileContext = createContext<ProfileContextValue>({
    profiles: [],
    selectedProfileId: null,
    ready: false,
});
